/* eslint-disable */
import GraphQL from '../../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InteractionToNextPaintWidgetQueryVariables = GraphQL.Exact<{
  date: GraphQL.Scalars['DateYMD']['input'];
  scope: GraphQL.Scalars['String']['input'];
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type InteractionToNextPaintWidgetQuery = { readonly __typename?: 'Query', readonly dashboardData: { readonly __typename?: 'DashboardData', readonly webVitalsOriginSummaryData: { readonly __typename?: 'WebsiteDashboardWebVitalsOriginSummaryData', readonly id: CK.ID, readonly pollInterval: number | null, readonly reasonForNoData: GraphQL.WebsiteDashboardReasonForNoData | null, readonly data: { readonly __typename?: 'WebVitalsOriginSummaryData', readonly interactionToNextPaint: { readonly __typename?: 'WebVitalsOriginMetric', readonly maximumFast: number, readonly maximumGood: number, readonly percentageFast: CK.Percentage, readonly percentageGood: CK.Percentage, readonly percentageSlow: CK.Percentage, readonly percentile: number, readonly verdict: GraphQL.WebVitalVerdict } | null } | null } } };


export const InteractionToNextPaintWidgetDocument = gql`
    query InteractionToNextPaintWidget($date: DateYMD!, $scope: String!, $websiteId: WebsiteId!) {
  dashboardData {
    webVitalsOriginSummaryData(date: $date, scope: $scope, websiteId: $websiteId) {
      data {
        interactionToNextPaint {
          maximumFast
          maximumGood
          percentageFast
          percentageGood
          percentageSlow
          percentile
          verdict
        }
      }
      id
      pollInterval
      reasonForNoData
    }
  }
}
    `;

/**
 * __useInteractionToNextPaintWidgetQuery__
 *
 * To run a query within a React component, call `useInteractionToNextPaintWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useInteractionToNextPaintWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInteractionToNextPaintWidgetQuery({
 *   variables: {
 *      date: // value for 'date'
 *      scope: // value for 'scope'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useInteractionToNextPaintWidgetQuery(baseOptions: Apollo.QueryHookOptions<InteractionToNextPaintWidgetQuery, InteractionToNextPaintWidgetQueryVariables> & ({ variables: InteractionToNextPaintWidgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InteractionToNextPaintWidgetQuery, InteractionToNextPaintWidgetQueryVariables>(InteractionToNextPaintWidgetDocument, options);
      }
export function useInteractionToNextPaintWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InteractionToNextPaintWidgetQuery, InteractionToNextPaintWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InteractionToNextPaintWidgetQuery, InteractionToNextPaintWidgetQueryVariables>(InteractionToNextPaintWidgetDocument, options);
        }
export function useInteractionToNextPaintWidgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InteractionToNextPaintWidgetQuery, InteractionToNextPaintWidgetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InteractionToNextPaintWidgetQuery, InteractionToNextPaintWidgetQueryVariables>(InteractionToNextPaintWidgetDocument, options);
        }
export type InteractionToNextPaintWidgetQueryHookResult = ReturnType<typeof useInteractionToNextPaintWidgetQuery>;
export type InteractionToNextPaintWidgetLazyQueryHookResult = ReturnType<typeof useInteractionToNextPaintWidgetLazyQuery>;
export type InteractionToNextPaintWidgetSuspenseQueryHookResult = ReturnType<typeof useInteractionToNextPaintWidgetSuspenseQuery>;
export type InteractionToNextPaintWidgetQueryResult = Apollo.QueryResult<InteractionToNextPaintWidgetQuery, InteractionToNextPaintWidgetQueryVariables>;